import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { StateService } from '../services/state.service';
import { ValidationError } from 'core-lib';

@Component({
  selector: 'cli-application-video',
  templateUrl: './application-video.component.html',
  styleUrls: ['./application-video.component.scss']
})
export class ApplicationVideoComponent implements OnInit {

  public vm: ApplicationVideoViewModel;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private stateSvc: StateService) {

    this.vm = new ApplicationVideoViewModel();

    this.vm.activationCode = this.route.snapshot.paramMap.get('id');
    this.vm.userName = this.route.snapshot.queryParamMap.get('username');
    this.vm.isNoEmail = this.route.snapshot.queryParamMap.get('email') === 'false';
  }

  ngOnInit() {
  }

  public next() {

    //let activationCode = this.vm.activationCode;
    //let userName = this.vm.userName;
    //let email = this.vm.isNoEmail ? 'false' : 'true';

    //this.router.navigateByUrl(`application-confirm/${activationCode}?username=${userName}&email=${email}`);
    
  }

}

export class ApplicationVideoViewModel {
  public isOpening: boolean;
  public isLoading: boolean;
  public errors: ValidationError[];
  public activationCode: string;
  public userName: string;
  public isNoEmail: boolean;
}
